export default __webpack_public_path__ + "static/media/plain-sticker-d.393741f3.png";